import { useEffect, useState } from "react";
import { Alert, Button, Card, CardBody, Container, Input, Label, Spinner } from "reactstrap";
import { FaCog, FaSave } from "react-icons/fa";
import useSystemSettings from "../../hooks/useSystemSettings";
import systemSettingsService from "../../services/systemSettingsService";

export default function SalesSettingsPage() {
  const settings = useSystemSettings();
  const [enabled, setEnabled] = useState(settings.droitTimbreEnabled);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  useEffect(() => { setEnabled(settings.droitTimbreEnabled); }, [settings.droitTimbreEnabled]);

  const save = async () => {
    setSaving(true);
    setMessage(null);
    try {
      await systemSettingsService.save(enabled);
      setMessage({ color: "success", text: "Le paramètre a été enregistré." });
    } catch {
      setMessage({ color: "danger", text: "Impossible d'enregistrer. Réessayez." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container className="py-4">
      <h1 className="h3 mb-3"><FaCog className="me-2" /> Paramètres de vente</h1>
      <Card>
        <CardBody>
          {settings.error && <Alert color="danger">{settings.error} <Button color="link" onClick={() => systemSettingsService.load().catch(() => {})}>Réessayer</Button></Alert>}
          {message && <Alert color={message.color} role="status">{message.text}</Alert>}
          <div className="form-check form-switch mb-3">
            <Input id="stamp-duty-enabled" type="switch" checked={enabled}
              disabled={!settings.loaded || settings.loading || saving}
              onChange={(event) => { setEnabled(event.target.checked); setMessage(null); }} />
            <Label for="stamp-duty-enabled" className="fw-bold">Droit de timbre : {enabled ? "activé" : "désactivé"}</Label>
          </div>
          <p>Activé : le droit de timbre de 0,25 % est ajouté à la part de la vente payée en espèces.</p>
          <p>Désactivé : aucun droit de timbre n'est calculé pour les nouvelles ventes. La ligne est masquée sur les écrans et les tickets.</p>
          <p className="text-muted">Les montants déjà enregistrés sur les anciens tickets restent conservés.</p>
          <Button color="primary" onClick={save} disabled={!settings.loaded || settings.loading || !!settings.error || saving || enabled === settings.droitTimbreEnabled}>
            {saving || settings.loading ? <Spinner size="sm" className="me-2" /> : <FaSave className="me-2" />} Enregistrer
          </Button>
        </CardBody>
      </Card>
    </Container>
  );
}
